import {Slot} from '@radix-ui/react-slot'
import type {HTMLAttributes} from 'react'

import {cn} from '@/lib/utils'

import {badgeVariants, type BadgeVariants} from './variants'

interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, BadgeVariants {
  asChild?: boolean
}

export function Badge({className, variant, asChild = false, ...props}: BadgeProps) {
  const Component = asChild ? Slot : 'span'
  return <Component data-slot="badge" className={cn(badgeVariants({variant}), className)} {...props} />
}
